// extracted by mini-css-extract-plugin
export var equalColumn = "_ft-0";